<template>
  <div class="row">
    <div class="col-md-12">
      <div class="text-center" v-if="userRoles === null">
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      </div>
      <template v-else>
        <DataTable
          ref="datatable"
          :startLoading="userRoles !== null"
          :width="'100%'"
          :settings="datatable.settings"
          :dataColumns="datatable.columns"
          :dataFeed="datatable.dataFeed"
          :dataHandle="datatable.handle"
          :dataTableHeight="datatable.height"
          :defaultSortBy="datatable.sortBy"
          :defaultOrderBy="datatable.orderBy"
          :allowView="allowView"
          :allowEdit="allowEdit"
          :allowDelete="allowDelete"
          :hasContextMenu="hasContextMenu"
        >
          <template slot="menuButtons" slot-scope="props">
            <template v-if="props.item && props.item.data">
              <li
                @click="$refs.datatable.viewItem($event, props.item.data)"
                v-if="allowView(props.item.data)"
              >View</li>
              <li
                @click="$refs.datatable.editItem($event, props.item.data)"
                v-if="allowEdit(props.item.data)"
              >Edit</li>
              <li
                @click="$refs.datatable.confirmDelete($event, props.item.data)"
                v-if="allowDelete(props.item.data)"
              >Delete</li>
            </template>
          </template>
        </DataTable>
        <!-- END DATA TABLE -->

        <ImportModule 
          ref="importModule"
          @reload="reload"
          :uploadURL="$root.WebService.user + '/import/upload'" 
          :confirmURL="$root.WebService.user + '/import/confirm'"/>

      </template>
    </div>
  </div>
</template>
<script>

import ImportModule from 'src/components/ImportModule'
import exportData from 'src/global/exportData.js'
import importData from 'src/global/importData.js'

export default {
  components: {
    ImportModule
  },
  data() {
    return {
      pageSettings: {
        pageTitle: 'User',
        sectionName: 'user',
        sectionIcon: 'fas fa-users',
        type: this.pageType,
        useDefault: false,
        webService: this.$root.WebService.user,
        navigation: [
          { name: 'User', route: 'user.index' }
        ],
        buttons: [],
        subSidebar: {
          buttons: [
            { name: 'User List', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'user.index' }) } },
            { name: 'Roles & Permission', icon: 'fas fa-file-download', action: () => { this.$router.push({ name: 'user.rolePermission.index' }) } },
          ]
        }
      },
      datatable: {
        settings: {
          sectionName: 'user',
          webService: this.$root.WebService.user,
        },
        dataFeed: null,
        handle: null,
        columns: [
          { key: 'email', title: 'Email Address', type: 'input', width: '35%', value: null },
          { key: 'name', title: 'Name', type: 'input', width: '10%', value: null },
          { key: 'short_name', title: 'Short Name', type: 'input', width: '10%', value: null },
          { key: 'roles', title: 'Role', type: 'select', width: '10%', value: null, itemDisplayKey: 'name', selectOptions: { valueKey: 'name', searchKey: 'name', displayKey: 'name', datas: [] } },
          {            key: 'active', title: 'Status', type: 'select', width: '10%', value: null, datafilter: this.$options.filters.booleanEnabledText, selectOptions:
            {
              key: 'active', valueKey: 'value', displayKey: 'title', datas: [{ value: 0, title: 'Disabled' }, { value: 1, title: 'Enabled' }]
            }
          },
          { key: 'created_at', title: 'Created At', type: 'datepicker', width: '25%', value: { from: null, to: null }, datafilter: this.$options.filters.dateFormat },
        ],
        sortBy: null,
        orderBy: 'desc',
        width: '100%',
        height: '70vh',
      },
      datas: [],
      userRoles: null,
      exportFunction: {
        url: this.$root.WebService.user + '/export',
        fileName: 'ExportUser'
      },
    }
  },
  created() {
    this.getUserRole()
  },
  mounted() {

    if (this.hasPermission('import user')) this.pageSettings.buttons.push({ name: 'Import', icon: 'fas fa-file-upload', action: this.importData })
    if (this.hasPermission('export user')) this.pageSettings.buttons.push({ name: 'Export', icon: 'fas fa-file-download', action: this.exportData })
    if (this.hasPermission('create user')) this.pageSettings.buttons.push({ name: 'Add New User', icon: 'fas fa-plus', action: this.addItem })

    this.$emit('setPageHeader', this.pageSettings)
    this.datatable.handle = (res) => this.datas = res.data.data
    this.datatable.dataFeed = {
      method: 'get',
      url: this.pageSettings.webService
    }
  },
  methods: {
    getUserRole() {
      this.$http
        .get(this.WebService.role)
        .then(res => {
          this.datatable.columns.find(i => i.key == 'roles').selectOptions.datas = this.userRoles = res.data.data
        })
        .catch(err => { console.log(err) })
        .finally(null)
    },
    addItem() {
      this.$router.push({ name: this.pageSettings.sectionName + '.create' })
    },
    exportData,
    importData,
    allowView(item) {
      return this.hasPermission('read user')
    },
    allowEdit(item) {
      return item.id !== 1 && this.hasPermission('update user')
    },
    allowDelete(item) {
      return false
      return item.id !== 1 && this.hasPermission('delete user') && this.$root.$data.AuthData.id !== item.id && false
    },
    hasContextMenu(item) {
      return this.allowView(item) || this.allowEdit(item) || this.allowDelete(item)
    },
    reload() {
      this.$refs.datatable.reload()
      //this.$emit('reloadParent', null, this.selectedVendorProject)
    }
  }
}
</script>